import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

export const CandidateCommitteeForm = ({ name, contactName, handleChange }) => (
  <Fragment>
    <TextField
      label="Committee Name"
      value={name}
      onChange={handleChange('name')}
    />
    <TextField
      label="Contact Name"
      value={contactName}
      onChange={handleChange('contactName')}
    />
  </Fragment>
);

CandidateCommitteeForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string,
  contactName: PropTypes.string,
};

CandidateCommitteeForm.defaultProps = {
  name: '',
  contactName: '',
};

export default CandidateCommitteeForm;
